import { Controller } from '@hotwired/stimulus'

import { adminInvoiceItemReview } from 'rails_routes'

// Connects to data-controller="transaction-mark-loss-dialog"
export default class extends Controller<HTMLElement> {
  static targets = [
    'dialog',
    'input',
  ]

  declare readonly dialogTarget: HTMLDivElement
  declare readonly inputTarget: HTMLInputElement

  open (event: Event): void {
    event.preventDefault()
    const button = event.currentTarget as HTMLButtonElement
    const transactionId = button.dataset.transactionId
    const transactionAmount = button.dataset.transactionAmount

    if (transactionId) {
      this.element.dataset.transactionId = transactionId
      this.inputTarget.value = transactionAmount || ''
      this.inputTarget.max = transactionAmount || ''
      this.dialogTarget.classList.remove('hidden')
    } else {
      console.error('Transaction ID is missing')
    }
  }

  close (event: Event): void {
    event.preventDefault()
    this.dialogTarget.classList.add('hidden')
  }

  async submit (event: Event): Promise<void> {
    event.preventDefault()

    const transactionId = this.element.dataset.transactionId
    const lossValue = this.inputTarget.value

    if (!transactionId || !lossValue) {
      alert('Missing transaction ID or loss value')
      return
    }

    // Create a form element to submit the request
    // This is being done so the rails controller can follow the normal flow for errors and redirects
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = adminInvoiceItemReview.markAsLoss({ invoice_item_review_id: transactionId })

    // Add the loss_value as a hidden input field
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'loss_value'
    input.value = lossValue

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    if (csrfToken) {
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }

    form.appendChild(input)

    // Append the form to the body, submit it, and remove it
    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)

    // Close the dialog immediately
    this.close(event)
  }
}
